import { render, staticRenderFns } from "./CreateBriefModal.vue?vue&type=template&id=66705fdd&scoped=true"
import script from "./CreateBriefModal.vue?vue&type=script&lang=js"
export * from "./CreateBriefModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66705fdd",
  null
  
)

export default component.exports